exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apc-react-body .audience-targeting span.saved-rule {\n  font-style: italic; }\n\n.apc-react-body .audience-targeting .segment-row {\n  display: flex;\n  margin-left: -10px; }\n  .apc-react-body .audience-targeting .segment-row > * {\n    margin-left: 10px; }\n\n.apc-react-body .audience-targeting .create-segments-link:hover {\n  text-decoration: none; }\n", ""]);

// exports
